import { supabase, hasSupabaseConfig } from './lib/supabase.js';
import { getSession, getProfile, onAuthChange, signIn, signOut } from './lib/auth.js';
import { renderLogin } from './views/login.js';
import { renderApp } from './views/app-shell.js';

const root = document.getElementById('app');

async function route() {
    if (!hasSupabaseConfig) {
        root.innerHTML = `
            <div class="setup-screen">
                <h1>Kapela – Setup</h1>
                <p>Supabase credentials nejsou nastavené.</p>
                <ol>
                    <li>Vytvoř Supabase projekt na <a href="https://app.supabase.com" target="_blank">app.supabase.com</a></li>
                    <li>V <em>SQL Editor</em> spusť <code>supabase/schema.sql</code> a <code>supabase/policies.sql</code></li>
                    <li>V <em>Settings → API</em> zkopíruj <strong>Project URL</strong> a <strong>anon key</strong></li>
                    <li>Vyplň <code>.env.local</code> a restartuj <code>npm run dev</code></li>
                </ol>
            </div>
        `;
        return;
    }

    const session = await getSession();
    if (!session) {
        renderLogin(root, async (email, password) => {
            await signIn(email, password);
        });
        return;
    }

    const profile = await getProfile();
    renderApp(root, { session, profile, onLogout: async () => { await signOut(); } });
}

// Při token-refresh / návratu do okna Supabase fire-uje různé eventy
// (TOKEN_REFRESHED, někdy i SIGNED_IN znovu). Plný re-render by resetoval
// aktivní záložku. Re-routujeme proto jen při SKUTEČNÉ změně uživatele.
let lastUserId = undefined; // undefined = ještě nenastaveno, null = odhlášený
onAuthChange((session) => {
    const newUserId = session?.user?.id || null;
    if (lastUserId !== undefined && newUserId === lastUserId) return; // beze změny
    lastUserId = newUserId;
    route();
});
route();
